/* Shared, bounded Customily canvas delivery. The provider's Fabric on/off and
 * after:render signal were verified in performance runtime evidence 2026-10-07.
 */
(() => {
  if (window.HanossCustomilyPreviewFrames) return;
  const clients = new Set();
  let provider;
  let scheduled;
  let burstUntil = 0;
  let burstFrame;
  let panelSubscription;
  const requestFrame = () => {
    if (scheduled || document.hidden) return;
    scheduled = requestAnimationFrame(() => {
      scheduled = null;
      if (document.hidden) return;
      for (const client of [...clients].sort((a, b) => a.priority - b.priority)) {
        if (!client.target.isConnected) { client.dispose(); continue; }
        if (client.visible) client.paint();
      }
    });
  };
  const bindProvider = () => {
    const next = window.engraver?.canvas;
    if (next === provider) return Boolean(provider);
    provider?.off('after:render', requestFrame);
    provider = null;
    if (typeof next?.on !== 'function' || typeof next?.off !== 'function') return false;
    provider = next;
    provider.on('after:render', requestFrame);
    requestFrame();
    return true;
  };
  const burst = () => {
    burstUntil = performance.now() + 1000;
    bindProvider();
    if (burstFrame || document.hidden) return;
    let lastState;
    const tick = () => {
      burstFrame = null;
      if (document.hidden) return;
      bindProvider();
      // Re-check late provider readiness without copying the same frame on
      // every rAF. Pixel changes come from after:render; these existing model
      // fields cover generation completion and late canvas replacement.
      const capabilities = window.HanossCustomilyCapabilities;
      const fields = capabilities?.getConfiguredFields();
      const model = capabilities?.optionModel(fields?.crosswordOption);
      const source = document.querySelector('.customily-modal-preview-only #preview-canvas');
      const state = [fields?.quote?.value, fields?.crossword?.value,
        model?.lastGeneratedValue, model?.loadingFunction, model?.generatedFunction,
        source?.width, source?.height].join('\u0000');
      if (state !== lastState) { lastState = state; requestFrame(); }
      if (performance.now() < burstUntil) burstFrame = requestAnimationFrame(tick);
    };
    burstFrame = requestAnimationFrame(tick);
  };
  const register = (target, paint, { priority = 0 } = {}) => {
    const client = { target, paint, priority, visible: false };
    const observer = new IntersectionObserver((entries) => {
      client.visible = entries.at(-1).isIntersecting;
      if (client.visible) requestFrame();
    });
    client.dispose = () => { observer.disconnect(); clients.delete(client); };
    clients.add(client);
    observer.observe(target);
    bindProvider();
    return client.dispose;
  };
  const discover = () => {
    bindProvider();
    if (!panelSubscription && window.HanossCustomilyCapabilities?.onPanelChange) {
      panelSubscription = window.HanossCustomilyCapabilities.onPanelChange(bindProvider);
    }
  };
  window.HanossCustomilyPreviewFrames = Object.freeze({ register, requestFrame, burst });
  for (const name of ['input', 'change', 'click']) document.addEventListener(name, (event) => {
    if (event.target?.closest?.('.customily_sets-panel, .customily-preview-button')) burst();
  }, true);
  document.addEventListener('hanoss:customily-capabilities', bindProvider);
  document.addEventListener('hanoss:customily-panel-ready', discover);
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) { bindProvider(); requestFrame(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, { once: true });
  else discover();
})();
